export default __webpack_public_path__ + "static/media/newlogo.e5d56371.png";